import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, Form } from 'react-bootstrap';
import { requestPasswordReset } from 'services/auth';

const ForgetPasswordForm = () => {
  // State
  const [email, setEmail] = useState('');
  const navigate = useNavigate();

  // Handler
  const handleSubmit = async e => {
    e.preventDefault();

    if (!email) {
      toast.error('Por favor, ingresa tu correo electrónico.');
      return;
    }

    try {
      const response = await requestPasswordReset(email);

      if (response.result) {
        toast.success(
          'Un correo fue enviado a tu email con un enlace para restablecer la contraseña.',
          {
            theme: 'light'
          }
        );
        navigate('/');
      } else {
        toast.error(
          response.message ||
            'No se pudo enviar el correo. Verifica tu dirección.'
        );
      }
    } catch (error) {
      toast.error('Error al solicitar el restablecimiento. Intenta de nuevo.');
    }
  };

  return (
    <Form className="mt-4" onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        <Form.Control
          placeholder={'correo electrónico'}
          value={email}
          name="email"
          onChange={({ target }) => setEmail(target.value)}
          type="email"
          required
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Button className="w-100" type="submit" disabled={!email}>
          Envíar enlace
        </Button>
      </Form.Group>
      <Link className="fs-10 text-600" to="/auth/login">
        ¿Ya tienes cuenta? Iniciar sesión
      </Link>
      <br></br>
      <Link className="fs-10 text-600" to="#!">
        No puedo recuperar mi cuenta utilizando esta página
        <span className="d-inline-block ms-1"> &rarr;</span>
      </Link>
    </Form>
  );
};

export default ForgetPasswordForm;
